import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import SellCarPage from "./pages/SellCarPageOptimal";
import BusinessPage from "./pages/BusinessPage";
import DealerPage from "./pages/DealerPage";
import MyPage from "./pages/MyPageComplete";
import FAQPage from "./pages/FAQPage";
import ThankYouPage from "./pages/ThankYouPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/selg-bilen" element={<SellCarPage />} />
          <Route path="/bedrift" element={<BusinessPage />} />
          <Route path="/forhandler" element={<DealerPage />} />
          <Route path="/min-side" element={<MyPage />} />
          <Route path="/ofte-stilte-sporsmal" element={<FAQPage />} />
          <Route path="/takk" element={<ThankYouPage />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
